module.exports = __webpack_public_path__ + "static/img/adminImg2.37344dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adminImg2.png
// module id = whBP
// module chunks = 2